import {BaseService} from './baseService.js';

/* 
 * Handles interaction with the security apis
 */
export class SecurityService extends BaseService {
	
	constructor() {	
		super();		
	}
	
	async getPolicy() {	
		var policy = await this.makeGETRequest('/api/resource/security-policy');
		return policy;		
	}
	
	async savePolicy(policy) {
		var updatedPolicy = await this.makePUTRequest('/api/resource/security-policy/', policy);
		return updatedPolicy;
	}
	
	async getSecurityRoles(companyId) {
		var companyId = companyId || 'current';
		var roles = await this.makeGETRequest('/api/resource/security-roles/company/' + companyId);		
		return roles;
	}
	
	async saveSecurityRole(role) {
		var savedRole;
		if (role.roleId) {
			savedRole = await this.makePUTRequest('/api/resource/security-roles/' + role.roleId, role);
		} else {
			savedRole = await this.makePOSTRequest('/api/resource/security-roles', role);
		}
		return savedRole;
	}
	
	async deleteSecurityRole(roleId) {		
		var result = await this.makeDELETERequest('/api/resource/security-roles/'+ roleId);
		return result;
	}	
	
	async addUserToSecurityRole(roleId, userId) {
		var result = await this.makePUTRequest('/api/resource/security-roles/' + roleId + '/users/' + userId);
		return result;
	}

	async removeUserFromSecurityRole(roleId, userId) {
		var result = await this.makeDELETERequest('/api/resource/security-roles/' + roleId + '/users/' + userId);
		return result;		
	}	
	
	async getUsersInSecurityRole(roleId) {	
		var users = await this.makeGETRequest('/api/resource/security-roles/' + roleId + '/users');		
		return users;
	}
	
	async getPermissionsInSecurityRole(roleId) {	
		var data = await this.makeGETRequest('/api/resource/security-roles/' + roleId + '/permissions');		
		return data;
	}	
	
};
